import { Button, Callout, Checkbox, Collapse, Intent, NumericInput, TextArea } from "@blueprintjs/core";
import autobind from "autobind-decorator";
import { IFieldProps } from 'decorator-form';
import * as React from "react";

import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import { registerField } from "common/form/register";
import { addEnum } from "typegraph";
import Logger from "../../../core/util/Logger";
import {default as CourseParams, ICourseParams } from "../entities/CourseParams";
import Tag from "../entities/Tag";

const TagsSelect = EntityMultiSelect.ofType(Tag, {pageSize: 1000}, {getSecondaryLabel: (tag: Tag) => tag.tagSet.name});

// TODO make nice
class CourseParamsField extends React.PureComponent<IFieldProps<ICourseParams>, {value: string, message: string, isOpen: boolean, intent: Intent}> {

	constructor(props: IFieldProps<ICourseParams>) {
		super(props);
		this.state = {value: JSON.stringify(props.formData), message: null, isOpen: false, intent: Intent.NONE};
	}

	private handleChange = (e: any) => {
		this.setState({value: e.target.value});
	}

	private save = () => {
		try {
			const data = JSON.parse(this.state.value);
			this.props.onChange(data);
			this.setState({message: "Saved", intent: Intent.SUCCESS, value: JSON.stringify(data)});
		} catch(e) {
			this.setState({message: "Invalid json. Not saved.", intent: Intent.DANGER});
		}

	}

	public render() {
		const { value, message, isOpen, intent } = this.state;

		return (
			<React.Fragment>
				<Button onClick={() => this.setState({ isOpen: !isOpen })}>
					{this.state.isOpen ? "Hide" : "Show"} editor
				</Button>
				<br />
				<Collapse isOpen={isOpen}>
					<Callout intent={Intent.NONE}>
						{message && (
							<Callout intent={intent}>
								{message}
							</Callout>
						)}
						<br />
						<TextArea
							large={true}
							intent={Intent.PRIMARY}
							onChange={this.handleChange}
							value={value}
							style={{minHeight: "200px"}}
							fill={true}
						/>
						<br /><br />
						<Button onClick={this.save}>
							Save
						</Button>
					</Callout>
				</Collapse>
			</React.Fragment>
		);

		/*return (
			<div>
				<h4>Filter Courses</h4>

				Search phrase
				<input value={data.query} onChange={(e) => this.onChange({query: e.target.value})} />
				<a onClick={() => this.onChange({query: null})}>Clear</a>

				Selected Tags
				<TagsSelect formData={data.tags} onChange={(d) => this.onChange({tagIds: d})} uiSchema={null} idSchema={null} />

				Subscriptions Only
				The user must have an active subscription to see these courses
				<Checkbox checked={data.subscribedOnly} onChange={(e: any) => this.onChange({subscribedOnly: e.target.checked})} />

				Featured Only
				Only show courses that have been marked as featured in the admin section
				<Checkbox checked={data.featuredOnly} onChange={(e: any) => this.onChange({featuredOnly: e.target.checked})} />

				Recommended Only
				Only show courses the system has recommended based on user preferences
				<Checkbox checked={data.recommendedOnly} onChange={(e: any) => this.onChange({recommendedOnly: e.target.checked})} />

				Page Size
				<NumericInput value={data.pageSize} onValueChange={(n) => this.onChange({pageSize: n})} />
			</div>
		);*/
	}
}

const registered = registerField(CourseParamsField, "object");
export default registered;



// WEBPACK FOOTER //
// ./src/panels/catalog/config/CourseParamsField.tsx